import { render, staticRenderFns } from "./CartRecap.vue?vue&type=template&id=66b31f75&scoped=true&"
import script from "./CartRecap.vue?vue&type=script&lang=js&"
export * from "./CartRecap.vue?vue&type=script&lang=js&"
import style0 from "./CartRecap.vue?vue&type=style&index=0&id=66b31f75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b31f75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b31f75')) {
      api.createRecord('66b31f75', component.options)
    } else {
      api.reload('66b31f75', component.options)
    }
    module.hot.accept("./CartRecap.vue?vue&type=template&id=66b31f75&scoped=true&", function () {
      api.rerender('66b31f75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/CartRecap.vue"
export default component.exports